<template>
  <div class="container-h-full">
    <div class="element card" style="padding:0">
      <div class="card-head" style="background:#F2F2F2;padding:0 18px">
        <p class="card-head-name">
          <i class="iconhebei iconbaoming2" style="color:#5A9BF6"></i>
          {{activity.name ||tickets.name}}
        </p>
        <template v-if="isSignup">
          <p class="price">{{activity.charge==0?"免费":activity.price}}</p>
        </template>
        <template v-else>
          <p class="price">{{tickets.isCharge==0?"免费":tickets.price}}</p>
        </template>
      </div>
      <div style="padding:0 18px">
        <div class="card-content flex-box">
          <template v-if="isSignup">
            <p class="time">
              <i class="iconhebei iconyuyue1"></i>
              参观日期：{{formatTime(activity.startTime)}} {{getTime(activity.startTime)}} - {{getTime(activity.endTime)}}
            </p>
          </template>
          <template v-else>
            <p class="time">
              <i class="iconhebei iconyuyue1"></i>
              参观日期：{{formatTime(order.startDate)}} {{getTime(order.startDate)}} - {{getTime(order.endDate)}}
            </p>
          </template>
          <p class="reservation">
            预约数：
            {{isSignup? applicants.length:visitors.length}}
          </p>
        </div>
        <div class="card-footer flex-box">
          <p class="status" :style="{color:codeStatus.color}">{{codeStatus.des}}</p>
          <router-link
            tag="p"
            v-if="codeStatus.QRCode"
            :to="{name:'QRCode',query:{type:type,id:id}}"
          >
            <i class="iconhebei iconerweima"></i>电子二维码
          </router-link>
        </div>
      </div>
    </div>

    <div class="element card">
      <div class="card-head b-m-1px">
        <p v-if="isSignup">
          <i class="iconhebei iconbaoming2" style="color:#5A9BF6"></i>
          报名单
        </p>
        <p v-else>
          <i class="iconhebei iconbaoming2" style="color:#5A9BF6"></i>
          订单号：{{order.orderNo}}
        </p>
      </div>
      <div class="card-content">
        <p class="m-b" v-show="order.orderTime">下单时间：{{order.orderTime}}</p>
        <p class="m-b">联系人：{{order.name}}</p>
        <p class="m-b">手机号：{{order.phone}}</p>
        <p class="m-b">身份证号：{{order.cardNo}}</p>
        <p class="m-b">订单备注：{{order.remark}}</p>
      </div>
    </div>

    <div class="search m-b">
      <van-search
        class="search-input"
        placeholder="请输入票号、游客姓名、证件号"
        v-model="searchValue"
        shape="round"
      />
      <div class="operating">
        <van-checkbox v-model="allChecked" checked-color="#5A9BF6" @change="toggleAll">全选</van-checkbox>
        <button class="cancel-btn" v-touch:tap="handleCancel">取消预约</button>
      </div>
    </div>
    <template v-if="isSignup">
      <template v-for="(item,index) in applicants">
        <van-checkbox-group
          ref="checkboxgroup"
          v-model="chekcedGroup"
          checked-color="#5A9BF6"
          :key="item.id"
        >
          <div class="element info" v-touch:tap="handleTapCheckbox(index)">
            <div class="info-content m-b">
              <van-checkbox ref="checkboxes" :name="item.id">游客{{index+1}}：{{item.name}}</van-checkbox>
              <p>{{item.cardNo}}</p>
            </div>
            <div class="info-content">
              <template v-if="isSignup">
                <p></p>
              </template>
              <template v-else>
                <p style="margin-left:28px;">票号：{{item.ticketNO}}</p>
              </template>
              <!-- <p style="font-size:12px;">{{getTicketCodeStatus(item.status)}}</p> -->
            </div>
          </div>
        </van-checkbox-group>
      </template>
    </template>
    <template v-else>
      <template v-for="(item,index) in visitors">
        <van-checkbox-group
          ref="checkboxgroup"
          v-model="chekcedGroup"
          checked-color="#5A9BF6"
          :key="item.id"
        >
          <div class="element info" v-touch:tap="handleTapCheckbox(index)">
            <div class="info-content m-b">
              <van-checkbox ref="checkboxes" :name="item.id">游客{{index+1}}：{{item.name}}</van-checkbox>
              <p>{{item.cardNo}}</p>
            </div>
            <div class="info-content">
              <template v-if="isSignup">
                <p></p>
              </template>
              <template v-else>
                <p style="margin-left:28px;">票号：{{item.ticketNo}}</p>
              </template>
              <p
                style="font-size:12px;"
                :style="{color:getTicketCodeStatus(item.status).color}"
              >{{getTicketCodeStatus(item.status).des}}</p>
            </div>
          </div>
        </van-checkbox-group>
      </template>
    </template>
  </div>
</template>

<script>
import { Search, Checkbox, CheckboxGroup, Button } from "vant";
import {
  applicationDetail,
  bookedDetail,
  activitiesUserCancel,
  ticketUserCancel
} from "@ticketUrl";
import util from "@util";

export default {
  name: "OrderDetail",
  components: {
    [Search.name]: Search,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button
  },
  inject: ["reload"],
  created() {
    let { id, type } = this.$route.query;
    this.isSignup = type === "signup";
    this.type = type;
    this.id = id;
    this.params = this.isSignup ? { signUpId: id } : { orderNo: id };
    this.getDetail();
  },
  computed: {
    codeStatus() {
      let state = this.$store.state;
      let config = this.isSignup
        ? state["signupOrderListStatusCode"]
        : state["ticketOrderListStatusCode"];
      return config[this.order.status] || {};
    },
    ticketCodeStatus() {
      let state = this.$store.state;
      let config = this.isSignup
        ? state["signupStatusCode"]
        : state["ticketStatusCode"];
      return config;
    }
  },
  data() {
    return {
      searchValue: "",
      allChecked: false,
      chekcedGroup: [],
      params: {},
      order: {}, //订单信息
      activity: {}, //活动-活动信息,
      applicants: [], //活动-人员信息
      tickets: {}, //门票-门票信息
      visitors: [], //门票- 游客信息
      isSignup: true,
      id: "",
      type: "signup"
    };
  },
  watch: {
    chekcedGroup(newValue) {
      let len = newValue.length;
      if (!len) {
        this.allChecked = false;
      } else if (this.isSignup && len === this.applicants.length) {
        this.allChecked = true;
      } else if (!this.isSignup && len === this.visitors.length) {
        this.allChecked = true;
      }
    }
  },
  methods: {
    getTicketCodeStatus(status) {
      if (!this.ticketCodeStatus) return;
      if (this.ticketCodeStatus[status]) return this.ticketCodeStatus[status];
    },
    formatTime(time) {
      return util.formatTime(new Date(time), "yyyy-MM-dd");
    },
    getTime(item) {
      return util.getTime(item);
    },
    getDetail() {
      let url = this.isSignup ? applicationDetail : bookedDetail;
      this.$http.get(url, { params: this.params }).then(res => {
        let {
          data: {
            order = {},
            activity = {},
            applicants = [],
            tickets = [],
            visitors = []
          }
        } = res;
        this.order = order;
        this.activity = activity;
        this.applicants = applicants;
        this.tickets = tickets[0];
        this.visitors = visitors;
      });
    },
    handleTapCheckbox(index) {
      return () => {
        this.$refs.checkboxes[index].toggle();
      };
    },
    toggleAll(status) {
      this.allChecked = status;
      this.$refs["checkboxgroup"][0].toggleAll(status);
    },

    //取消预约（活动）
    handleCancel() {
      if (!this.chekcedGroup.length) return;
      this.$dialog
        .confirm({
          message: "是否确认取消？"
        })
        .then(() => {
          let url = this.isSignup ? activitiesUserCancel : ticketUserCancel;
          this.$http.post(url, { users: this.chekcedGroup }).then(res => {
            let { msg: message } = res;
            this.$toast.success({
              message,
              onClose: () => {
                this.$toast({
                  type: "success",
                  message: "已删除该订单",
                  onClose: () => {
                    this.reload();
                  }
                });
              }
            });
          });
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>
<style lang="less" scoped>
.element {
  font-size: 14px;
  color: #8c8c8c;
  background: #ffffff;
  margin-bottom: 12px;
  padding: 0 13px 0 17px;
}
.m-b {
  margin-bottom: 10px;
}
.card {
  .b-m-1px {
    border-bottom: 0.5px solid #ebedf0;
  }
  .flex-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &-head,
  &-footer {
    min-height: 50px;
    line-height: 50px;
  }
  &-head {
    color: #606060;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    .iconhebei {
      color: #ababab;
    }
    .price {
      color: #ff9e15;
    }
    .status {
      color: #27af2d;
    }
  }
  &-head-name{
    min-height: 50px;
    flex: 1;
    line-height: initial;
    display: flex;
    align-items: center;
    .iconhebei{
      margin-right: 5px;
    }
  }
  &-content {
    font-size: 12px;
    padding: 12px 8px 16px 8px;
    .reservation {
      text-align: right;
      color: #b3b3b3;
    }
    .iconhebei {
      font-size: 14px;
      color: #ababab;
    }
    .time {
      color: #606060;
    }
  }
  &-footer {
    text-align: right;
    color: #606060;
    font-size: 12px;
    .iconhebei {
      transform: translateY(2px);
      margin-right: 8px;
      display: inline-block;
    }
  }
}

.search {
  background: #ffffff;
  padding: 20px 10px;
  &-input {
    padding: 0 !important;
    margin-bottom: 20px;
  }
  .cancel-btn {
    width: 84px;
    height: 26px;
    font-size: 12px;
    color: #5ca2fd;
    border-radius: 14px;
    // border: 1px solid #DFEEFF;
    background: #dfeeff;
    // &.disabled {
    //   border: 1px solid #ebedf0;
    //   color: #ebedf0;
    // }
  }
  .operating {
    padding: 0 7px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.info {
  color: #606060;
  padding-top: 20px;
  padding-bottom: 20px;
  &-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>